import type { APIHomeSection } from "~/api/commonApi";

export default function getPoster(data:APIHomeSection): APIHomeSection['posters'] {
  const poster = Array.isArray(data.posters)
    ? {
      desktop: Object.values(data.images)[0],
      mobile: Object.values(data.images)[0]
    }
    : data.posters

  return poster
}
